import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  taskList: { data: [], loading: false },
  taskDetail: { data: [], loading: false },
  textureList: { data: [], raw: [], loading: false },
  iesList: { data: [], raw: [], loading: false },
  matList: { data: [], loading: false },
  checkList: {
    data: [],
    completed: false,
    loading: false,
    requiresDesignMigration: false,
    canSkipDesignMigration: false,
    missingBrandCount: 0,
  },
  taskCheck: { uuid: '', result: false, loading: false },
  confirm: { name: '', title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
